import React, { FC, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import styled from '@mui/styles/styled';
import { ContactAdminButton } from './ContactAdminButton';
import Button from '@mui/material/Button';
import { useDialog } from '../../hooks/useDialog';
import { Link } from 'react-router-dom';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { CurrentUserContext } from '../../contexts/CurrentUserContext';
import { useAuth } from '../../hooks/useAuth';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

interface IProps {
  title?: string;
  description?: string;
  showContactAdmin?: boolean;
  organizationContext?: boolean;
  showLogoutButton?: boolean;
}

export const Nothing: FC<IProps> = ({
  title,
  description,
  organizationContext = false,
  showContactAdmin = true,
  showLogoutButton = false,
}) => {
  const { t } = useTranslation();
  const { organization } = useContext(OrganizationContext);
  const { userInfo } = useContext(CurrentUserContext);
  const { logOut } = useAuth();

  const { openUrl: changeOrgUrl } = useDialog('organization');
  const showOrganization = organizationContext && (userInfo?.organizations?.length ?? 0) > 1;
  const showButtons = showOrganization || showContactAdmin || showLogoutButton;

  return (
    <Container>
      <img src="/images/nothing.svg" />
      <Typography variant="h4" textAlign={'center'}>
        {title ?? (
          <Trans
            i18nKey={showOrganization ? 'nothing.organizationContextTitle' : 'nothing.title'}
            values={{ organization: organization?.name }}
            components={{
              strong: <strong />,
            }}
          />
        )}
      </Typography>
      <Typography variant="h5" mt={3} mb={4} textAlign={'center'}>
        {description ?? (showOrganization ? t('nothing.organizationContextDescription') : t('nothing.description'))}
      </Typography>
      {showButtons ? (
        <ButtonsContainer>
          {showOrganization ? (
            <Button variant={'outlined'} component={Link} to={changeOrgUrl}>
              Change Organization
            </Button>
          ) : null}
          {showContactAdmin ? <ContactAdminButton /> : null}
          {showLogoutButton ? (
            <Button variant="contained" color="primary" onClick={logOut}>
              {t('layout.accountItems.logOut')}
            </Button>
          ) : null}
        </ButtonsContainer>
      ) : null}
    </Container>
  );
};
